import commonApi from './CommonApi.js';

export default {

    getAllNotifications: async (parameters) => {
        return await commonApi().get('/notificationPortal/getAllNotifications', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getNotification: async (parameters) => {
        return await commonApi().get('/notificationPortal/getNotification', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    }
}
